import moment from 'moment';

// API dates represent calendar days in India, serialized as UTC timestamps.
const INDIA_OFFSET_MINUTES = 330;

const combineDateAndTime = (dateValue, timeValue, endOfDay = false) => {
  if (!dateValue) return null;
  const date = moment.utc(dateValue, moment.ISO_8601, true).utcOffset(INDIA_OFFSET_MINUTES);
  if (!date.isValid()) return null;

  const day = date.format('YYYY-MM-DD');
  if (!timeValue) {
    const boundary = moment.utc(day, 'YYYY-MM-DD', true).utcOffset(INDIA_OFFSET_MINUTES, true);
    return endOfDay ? boundary.endOf('day') : boundary.startOf('day');
  }

  const result = moment.utc(
    day + ' ' + String(timeValue).trim(),
    ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss'],
    true,
  ).utcOffset(INDIA_OFFSET_MINUTES, true);
  return result.isValid() ? result : null;
};

export const getEventSchedule = (event) => {
  const startDate = event.event_start_date || event.event_date;
  const startTime = event.event_start_time || event.event_time;
  const endDate = event.event_end_date || startDate;
  return {
    start: combineDateAndTime(startDate, startTime),
    end: combineDateAndTime(endDate, event.event_end_time, true),
    hasStartTime: Boolean(startTime),
    hasEndTime: Boolean(event.event_end_time),
  };
};

export const getEventStatus = ({ start, end }, now = Date.now()) => {
  if (!start || !end || end.isBefore(start)) return 'unscheduled';
  if (now < start.valueOf()) return 'upcoming';
  if (now < end.valueOf()) return 'ongoing';
  return 'past';
};
